import H1 from "../../assets/n1.jpg";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Navbar from "../../component/JinraiUI/Navbar";
import Footer from "../../component/JinraiUI/Footer";
import ScreenshotImage from "../../assets/c1.jpg"
import PortfolioProjectCardLeft from "../../component/JinraiUI/Home/PortfolioProjectCardLeft";
import PortfolioProjectCardRight from "../../component/JinraiUI/Home/PortfolioProjectCardRight";
import L1 from "../../assets/inventory-logo-removebg.png";
import L2 from "../../assets/event-logo.jpeg";
import L3 from "../../assets/shriramHomeDecorLogo.jpeg";
import L4 from "../../assets/UforceLogo.jpeg";
import L5 from "../../assets/aquariushomesLogo.png";
import s1 from "../../assets/s1-uforce.png";
import s2 from "../../assets/s2-event.png";
import s3 from "../../assets/s3-amber.png";
import s4 from "../../assets/s4-homedecor.png";
import s5 from "../../assets/s5-aquariushomes.png";
import s6 from "../../assets/s6-aquariushomes.png";
import s7 from "../../assets/s7-aquariushomes.png";


const Clients = () => {
    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "home",
                "item": "https://jinraitech.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Clients",
                "item": "https://jinraitech.com/Clients"
            }
        ]
    };

    return (
        <>
            <Navbar />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
            />

            <section className="relative flex flex-col items-center justify-center md:h-[80vh] h-[60vh] bg-[#f4f4f4] overflow-x-hidden">
                <img
                    src={H1}
                    alt="Background of an innovative agency providing expert project management and technology solutions"
                    className="absolute inset-0 object-cover md:h-[70vh] h-[50vh]  w-full"
                />

                {/* Black Overlay */}
                <div className="absolute inset-0 bg-[#852D2D] opacity-30 md:h-[70vh] h-[50vh] "></div>

                {/* Content */}
                <div className="relative z-10 text-center text-white overflow-x-hidden">
                    <motion.h1
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{
                            delay: 0.2,
                            x: { type: "spring", stiffness: 60 },
                            opacity: { duration: 1 },
                            ease: "easeIn",
                            duration: 1,
                        }}
                        className="md:text-7xl text-4xl font-bold leading-tight mb-8"
                    >
                        Clients
                    </motion.h1>

                    <motion.div
                        initial={{ y: 100, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{
                            delay: 0.6,
                            y: { type: "spring", stiffness: 60 },
                            opacity: { duration: 0.7 },
                            ease: "easeIn",
                            duration: 1,
                        }}
                        className="flex justify-center items-center space-x-4 px-6 py-2 md:mx-64"
                    >
                        <Link to="/" className="py-2 transition text-[16px]">
                            Home
                        </Link>
                        <span className=" py-2 transition">{`->`}</span>
                        <Link to="/Clients" className="py-2 transition text-[16px]">
                            Clients
                        </Link>
                    </motion.div>
                </div>
            </section>

            <section className="bg-gray-100 pb-20 text-center overflow-x-hidden">
                <h2 className="text-gray-600 text-sm font-semibold uppercase mb-2">
                    Our Clients
                </h2>
                <h2 className="my-2 md:text-4xl text-3xl text-[--bg-color] font-bold ">
                    Here are some of our clients
                </h2>
                <div className="flex justify-center mb-5">
                    <div className="md:w-[400px] w-[200px] border-b-4 border-[--bg-color] mb-8"></div>
                </div>
                {/*  */}
                    <PortfolioProjectCardRight
                        title="Website Design & Development for Aquarius Homes"
                        images={[s5, s6, s7]}
                        // imageSrc={s5}
                        logoSrc={L5}
                        heading="Aquarius Homes"
                        description="Aquarius Homes is a modern, experience-led website that showcases premium residential and commercial spaces with clarity and confidence. It combines project highlights, floor plans, amenities, and virtual tours in a clean, responsive layout that helps buyers explore and enquire effortlessly while reinforcing the brand’s focus on smart, trustworthy living."
                        link="https://aquariushomes.in//"
                    />
                {/*  */}
                <div className="md:block hidden">
                    <PortfolioProjectCardLeft
                        title="Website Design & Development for UForce Foundation"
                        images={[s1]}
                        logoSrc={L4}
                        heading="UForce Foundation"
                        description="We built a modern, purpose-driven website for UForce Foundation to amplify their mission of empowering children, women, and underserved communities. The platform highlights their initiatives, impact stories, donation flows, and volunteer programs — crafted with a clean, responsive design that communicates their cause with clarity and compassion."
                        link="https://uforcefoundation.com/"
                    />
                </div>
                <div className="md:hidden block">
                    <PortfolioProjectCardRight
                        title="Website Design & Development for UForce Foundation"
                        images={[s1]}
                        logoSrc={L4}
                        heading="UForce Foundation"
                        description="We built a modern, purpose-driven website for UForce Foundation to amplify their mission of empowering children, women, and underserved communities. The platform highlights their initiatives, impact stories, donation flows, and volunteer programs — crafted with a clean, responsive design that communicates their cause with clarity and compassion."
                        link="https://uforcefoundation.com/"
                    /></div>
                <PortfolioProjectCardRight
                    heading="The Eventagious"
                    images={[s2]}
                    logoSrc={L2}
                    title="Private Theater Booking Platform for The Eventagious"
                    description="We developed an engaging, user-friendly website for The Eventagious, India’s leading private theater for celebrations. The platform enables seamless event booking, real-time availability checks, gallery browsing, and customized event packages — all built to deliver a premium experience to their customers."
                    link="https://theeventagioustown.com/"
                />
                <div className="md:block hidden">
                    <PortfolioProjectCardLeft
                        heading=" Shri Ram Home Decor"
                        images={[s4]}
                        logoSrc={L3}
                        title="Business Website for Shri Ram Home Decor"
                        description="We developed a clean, professional website for Shri Ram Home Decor to showcase their range of high-quality products. Designed as an informative brochure site, it highlights product categories, brand story, and contact details — helping the business establish a strong digital presence and build trust with potential customers."
                        link="https://shriramhomedecor.com/"
                    /></div>
                <div className="md:hidden block">
                    <PortfolioProjectCardRight
                        heading=" Shri Ram Home Decor"
                        images={[s4]}
                        logoSrc={L3}
                        title="Business Website for Shri Ram Home Decor"
                        description="We developed a clean, professional website for Shri Ram Home Decor to showcase their range of high-quality products. Designed as an informative brochure site, it highlights product categories, brand story, and contact details — helping the business establish a strong digital presence and build trust with potential customers."
                        link="https://shriramhomedecor.com/"
                    /></div>
                <PortfolioProjectCardRight
                    heading=" Amber Silk Mills"
                    images={[s3]}
                    logoSrc={L1}
                    title="Invoice System for Amber Silk Mills"
                    description="For Amber Silk Mills, we designed a rweb-based invoicing and business management system tailored to the textile industry. The solution supports streamlined invoice creation, edition , print pdfs — enhancing operational efficiency and accuracy.

"
                    link="https://jinraitech.com/inventory/login"
                />

            </section>
            <Footer />
        </>
    );
};

export default Clients;
